/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Init_BtnInputs */

const en_team_init_btn = /** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialize Team Workspace`)
};

const es_team_init_btn = /** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializar Espacio de Equipo`)
};

const fr_team_init_btn = /** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialiser l'espace de travail`)
};

const de_team_init_btn = /** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team-Arbeitsbereich initialisieren`)
};

const id_team_init_btn = /** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inisialisasi Ruang Kerja Tim`)
};

/** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */
const ja_team_init_btn = en_team_init_btn;

/** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */
const zh_team_init_btn = en_team_init_btn;

/** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */
const ar_team_init_btn = en_team_init_btn;

/** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */
const it_team_init_btn = en_team_init_btn;

/** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */
const ru_team_init_btn = en_team_init_btn;

/** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */
const pt_team_init_btn = en_team_init_btn;

/** @type {(inputs: Team_Init_BtnInputs) => LocalizedString} */
const ko_team_init_btn = en_team_init_btn;

/**
* | output |
* | --- |
* | "Initialize Team Workspace" |
*
* @param {Team_Init_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_init_btn = /** @type {((inputs?: Team_Init_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Init_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_init_btn(inputs)
	if (locale === "es") return es_team_init_btn(inputs)
	if (locale === "fr") return fr_team_init_btn(inputs)
	if (locale === "de") return de_team_init_btn(inputs)
	if (locale === "ja") return ja_team_init_btn(inputs)
	if (locale === "zh") return zh_team_init_btn(inputs)
	if (locale === "ar") return ar_team_init_btn(inputs)
	if (locale === "id") return id_team_init_btn(inputs)
	if (locale === "it") return it_team_init_btn(inputs)
	if (locale === "ru") return ru_team_init_btn(inputs)
	if (locale === "pt") return pt_team_init_btn(inputs)
	return ko_team_init_btn(inputs)
});